import React, { useState, useEffect } from "react";
import styled from "styled-components";

interface ImagePdfDropzoneDisabledProps {
  base64: string;
  width?: number;
  height?: number;
  uploadMessage?: string;
}

interface DropContainerProps {
  hasImage: boolean;
  customHeight?: number;
}

const DropContainer = styled.div<DropContainerProps>`
  height: ${({ hasImage, customHeight }) =>
    hasImage ? `${customHeight ?? 145}px` : "auto"};
  border: 2px dashed #cccccc;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  background-color: white;
  
  &:hover {
    border-color: #cccccc;
  }
`;

const MediaContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const UploadedImage = styled.img<{ width?: number; height?: number }>`
  max-width: calc(100% - 40px);
  max-height: ${({ height }) =>
    height ? `calc(${height}px - 60px)` : "125px"};
  object-fit: cover;
`;

const PdfIndicator = styled.div`
  text-align: center;
  font-size: 14px;
  color: #666;
  font-weight: bold;
`;

const UploadMessage = styled.p`
  text-align: center;
  font-size: 14px;
  color: #999999;
`;

const ImagePdfDropzoneDisabled: React.FC<ImagePdfDropzoneDisabledProps> = ({ base64, width, height, uploadMessage }) => {
  const [isImage, setIsImage] = useState(false);
  const [isPdf, setIsPdf] = useState(false);

  useEffect(() => {
    if (base64) {
      if (base64.startsWith("data:image")) {
        setIsImage(true);
        setIsPdf(false);
      } else if (base64.includes("application/pdf")) {
        setIsPdf(true);
        setIsImage(false);
      }
    }
  }, [base64]);

  return (
    <DropContainer hasImage={isImage || isPdf} customHeight={height}>
      {isImage ? (
        <MediaContainer>
          <UploadedImage src={base64} width={width} height={height} />
        </MediaContainer>
      ) : isPdf ? (
        <PdfIndicator>
          <p>📄 PDF Selecionado</p>
        </PdfIndicator>
      ) : (
        <UploadMessage
          dangerouslySetInnerHTML={{
            __html: uploadMessage || "Nenhum arquivo selecionado",
          }}
        />
      )}
    </DropContainer>
  );
};

export { ImagePdfDropzoneDisabled };
